import type { Status, Nullable } from './common'
import type { User } from './user'
import type {
  Activity,
  ActivityRelationSettings,
  ActivityType,
  RelationType,
} from './activity'
import type { BreakoutSettings } from './breakout'
import { ActivityGroupSettingsAiDifficulty } from './activity-group-settings'
import type { Room, RoomId } from './room'

export type ActivityGroupActivity = {
  id: number
  activityGroupId: number
  activityId: number
  position: number
  activity: Activity
  settings: { breakout?: BreakoutSettings }
  required?: Nullable<boolean>
}

export type ActivityGroupRelation = {
  id: number
  activityGroupId: ActivityGroupId
  leftId: ActivityGroupActivityId
  rightId: ActivityGroupActivityId
  type: RelationType
  settings: ActivityRelationSettings
}

export type ActivityGroupRoom = {
  id: number
  roomId: RoomId
  room: Room
  position: number
}

export type ActivityGroup = {
  id: number
  name: string
  settings?: {
    ai?: {
      prompt: string
      n: number
      type: ActivityType
      difficulty: ActivityGroupSettingsAiDifficulty
      media: boolean
      options: number
    }
  }
  externalName?: string
  status: Status
  tags: string[]
  category?: Nullable<ActivityGroupCategory>
  description?: string
  originId?: number
  activities: ActivityGroupActivity[]
  relations: ActivityGroupRelation[]
  rooms: ActivityGroupRoom[]
  createdAt: string
  updatedAt: string
  updatedBy?: User
  workspaceId?: Nullable<number>
  asynchronous: boolean
  nOfActivitiesToComplete?: number
}

export type ActivityGroupId = ActivityGroup['id']

export type ActivityGroupActivityId = ActivityGroupActivity['id']

export type ActivityGroupRelationId = ActivityGroupRelation['id']

export enum ActivityGroupCategory {
  ANYTIME = 'anytime',
  INTRO = 'intro',
  SNEAK = 'sneak',
  PLANT = 'plant',
  TRIVIA = 'trivia',
  BRAIN_BURNER = 'brain_burner',
  HEAD_TO_HEAD = 'head_to_head',
  CREATIVE = 'creative',
  FILLER = 'filler',
  START_TRACK = 'start_track',
  END_TRACK = 'end_track',
}
